import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { fetchBanners } from '@/api/bannerApi';
import { url } from '@/consts/url';
import {
  FetchBannersParams,
  FetchBannersResponse,
} from '@/types/api/bannerApi';
import { hidePreloader, showPreloader } from '@/utils/preloader';

type UseFetchBannersParams = FetchBannersParams & {
  /** 画面側でスケルトン表示する場合は全画面プリローダーを出さない */
  disablePreloader?: boolean;
};

export const useFetchBanners = ({
  m_mt_service_category_id,
  m_affiliate_id,
  limit,
  disablePreloader = false,
}: UseFetchBannersParams) => {
  const [data, setData] = useState<FetchBannersResponse['data']>();
  const [banners, setBanners] =
    useState<FetchBannersResponse['data']['m_banners']>();
  const [error, setError] = useState<AxiosError>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // 法人IDが未確定（顧客情報の取得前は 0）のうちは投げない。
    // 投げると 0 件の応答が返り、それが後着すると空表示のまま固定されてしまう。
    if (!m_affiliate_id) return;

    // 法人IDが変わると再取得が走る。前のリクエストが後から返って
    // 新しい結果を上書きしないよう、古い応答は破棄する。
    let isCurrent = true;

    setIsLoading(true);
    if (!disablePreloader) showPreloader();

    const fn = async () => {
      try {
        const res = await fetchBanners({
          m_mt_service_category_id,
          m_affiliate_id,
          limit,
        });
        if (!isCurrent) return;
        const data = res.data;

        const banners = data.m_banners;

        setData(data);
        setBanners(banners);
      } catch (err) {
        if (isCurrent) setError(err as AxiosError);
      } finally {
        if (isCurrent) setIsLoading(false);
        if (!disablePreloader) hidePreloader();
      }
    };

    fn();

    return () => {
      isCurrent = false;
    };
  }, [limit, m_affiliate_id, m_mt_service_category_id, disablePreloader]);

  return {
    data,
    error,
    banners,
    isLoading,
  };
};

// バナー画像のパスを生成
export const getBannerImageSrc = (path?: string) => {
  return path ? url.MOBICON_API + window.btoa(path) : url.MOBICON_API;
};
